import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EmployeeInfoService } from '@core/services/employee-info.service';
import { PortalSettingsService } from '@core/services/portal-settings.service';
import { PortalModulesService } from '@core/services/portal-modules.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../services/event.service';
import { SmOfflineService } from '@pages/sm/services/sm-offline.service';
import { SmService } from '@pages/sm/services/sm.service';
import { SmDataService } from '@pages/sm/services/sm-data.service';
import { SmSharedService } from '@pages/sm/services/sm-shared.service';
import { Router } from '@angular/router';
import { UtilityService } from '@core/services/utility.service';
import { HttpClient } from '@angular/common/http';
import { forkJoin, of, Subscription, switchMap } from 'rxjs';
import { HostListener } from '@angular/core';

import { ConfirmationModalComponent } from 'src/app/modals/sm/confirmation-modal/confirmation-modal.component';
import { ClockOutModalComponent } from 'src/app/modals/sm/clock-out-modal/clock-out-modal.component';
import { ClockInModalComponent } from 'src/app/modals/sm/clock-in-modal/clock-in-modal.component';

@Component({
  selector: 'app-sm-nav',
  templateUrl: './sm-nav.component.html',
  styleUrls: ['./sm-nav.component.css'],
})
export class SmNavComponent implements OnInit, OnDestroy {
  portalSettings: any;
  employeeInfo: any;
  formData: Record<string, any> = {};
  notTech: boolean;
  logoUrl: string;
  showSMManagerDash = false;
  showWODash = false;
  showServiceHub = false;
  enablePWA: boolean;
  isServiceManager = false;
  private subscriptions: Subscription[] = [];
  private serviceHubLink: string;
  private document = inject(DOCUMENT);
  private readonly smOfflineService = inject(SmOfflineService);
  private window = this.document.defaultView;
  constructor(
    portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    private ngbModalService: NgbModal,
    private router: Router,
    public HttpClient: HttpClient,
    private eventService: EventService,
    private utilityService: UtilityService,
    private smService: SmService,
    public smDataService: SmDataService,
    private smSharedService: SmSharedService,
    private portalModulesService: PortalModulesService
  ) {
    portalSettingsService.portalSettings$.subscribe(latestSettings => {
      this.portalSettings = latestSettings;
    });
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub?.unsubscribe());
  }

  ngOnInit(): void {
    this.enablePWA = true;

    this.formData = {};
    this.formData.enableOfflineAccess = this.employeeInfo.EnableOfflineFS;
    this.smDataService.currentOnline = navigator.onLine;
    this.logoUrl = '/Company/GetLogo?co=' + this.employeeInfo.PRCo + '&size=S';

    this.subscriptions.push(this.eventService.on('modulesChanged', () => this.getModules()));

    if (sessionStorage.getItem('SMWODashToManID') != null || sessionStorage.getItem('SMWODashToManIDWithTrip') != null) {
      this.smDataService.isFromSMWODashNow = true;
    }
    if (window.location.protocol == 'http:' && window.location.hostname != 'localhost') this.enablePWA = false;

    this.subscriptions.push(this.eventService.on('turnoffOffline', () => this.turnoffOffline()));
    this.subscriptions.push(this.eventService.on('triggerOfflinePost', () => this.triggerOfflinePost()));
    this.subscriptions.push(this.eventService.on('notTech', eventData => (this.notTech = eventData.data)));
    this.subscriptions.push(this.eventService.on('navClockStatus', eventData => this.navClockStatus(eventData)));
    this.isServiceManager = window.location.pathname == '/sm/workorderdashboard';
    this.getModules();
    this.serviceHubLink = this.portalSettings.ServiceHubLink.ConfigValue;
  }

  private navClockStatus(eventData) {
    setTimeout(() => {
      this.smDataService.clockEmpty = false;
      this.smDataService.clockInStatus = null;

      if (eventData.data == null) this.smDataService.clockEmpty = true;
      else this.smDataService.clockInStatus = eventData.data;
    });
  }

  public getModules() {
    this.showSMManagerDash = false;
    this.showWODash = false;
    this.showServiceHub = false;

    this.portalModulesService.getPortalModules().forEach(val => {
      if (val.ModuleID == 116) {
        this.showSMManagerDash = true;
      }
      if (val.ModuleID == 110) {
        this.showWODash = true;
      }
      if (val.ModuleID == 143) {
        this.showServiceHub = true;
      }
    });
  }

  public openGlobalNav() {
    document.getElementById('globalSideNav').style.width = '100%';
  }

  public closeGlobalNav(route) {
    document.getElementById('globalSideNav').style.width = '0';

    if (route == 'manage') {
      this.smDataService.isFromSMWODashNow = false;
      this.smDataService.isFromSMWODashNowWithTrip = false;
      this.smDataService.isClockOut = false;
      this.smDataService.isCloseOut = false;
      this.smDataService.isDrillDown = false;
      this.smSharedService.resetPage(true, false, true);
      this.smSharedService.removeSession();
      this.isServiceManager = false;
    } else if (route == 'service') {
      this.isServiceManager = true;
      this.smSharedService.removeSession();
    }
  }

  public clockAction() {
    if (this.smDataService.clockInStatus != null && this.smDataService.clockInStatus.ClockAction) {
      const modalRef = this.ngbModalService.open(ClockOutModalComponent, { size: 'md', backdrop: 'static' });
      modalRef.componentInstance.woData = null;
      modalRef.componentInstance.clockStatus = this.smDataService.clockInStatus;
      modalRef.componentInstance.isTripExist = true;

      modalRef.result.then(response => {
        this.smSharedService.resetPage(false, true, true);
        this.smDataService.currentWorkOrder = null;
        this.smDataService.isClockOut = true;
      });
    } else {
      const modalRef = this.ngbModalService.open(ClockInModalComponent, { size: 'md', backdrop: 'static' });

      modalRef.result.then(response => {
        this.eventService.broadcast('smClockInAction');
        this.smDataService.isClockOut = false;
      });
    }
  }

  public triggerOfflinePost() {
    const modalRef = this.ngbModalService.open(ConfirmationModalComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.body = this.smDataService.offlinePostCallList.length + ' items need to be synced to the portal.';
    modalRef.componentInstance.header = 'Sync Data to Portal';
    modalRef.result.then(response => {
      if (response) {
        this.smOfflineService.clearObjectStore('SM_OfflineSyncFail').subscribe({
          next: () => {
            this.smDataService.haveOfflinePostFail = false;
          },
          error: () => {
            this.utilityService.closeModal();
          },
        });
        this.startOfflinePost(0);
      } else {
        this.smOfflineService.getRecords<any>('SM_PostCalls').subscribe({
          next: offlinePostCallList => {
            setTimeout(() => {
              this.smDataService.offlinePostCallList = offlinePostCallList;
              if (offlinePostCallList.length > 0) {
                this.smDataService.haveOfflinePost = true;
              } else {
                this.smDataService.haveOfflinePost = false;
              }
              this.checkofflinePost();
              this.utilityService.closeModal();
            });
          },
          error: () => {
            this.utilityService.closeModal();
          },
        });
      }
    });
  }

  public startOfflinePost(index) {
    if (index >= this.smDataService.offlinePostCallList.length) {
      this.utilityService.openModal();
      this.smDataService.modalMsg = 'Offline Syncing...';

      const deleteObservables = this.smDataService.offlinePostCallList
        .filter(val => val.success)
        .map(val => this.smOfflineService.deleteRecords('SM_PostCalls', [val.id]));

      const workCompletedDeletionObservables = this.smDataService.offlinePostCallList
        .filter(val => val.success && val.url.toLowerCase().indexOf('insertupdatesmworkcompleted') > -1)
        .map(val =>
          this.smOfflineService.getRecords<any>('SM_GetWorkCompleted').pipe(
            switchMap(SM_GetWorkCompletedList => {
              const idsToDelete = SM_GetWorkCompletedList.filter(val2 => val.payload.SMWorkCompletedID === val2.SMWorkCompletedID).map(
                val2 => val2.SMWorkCompletedID
              );

              if (idsToDelete.length > 0) {
                return this.smOfflineService.deleteRecords('SM_GetWorkCompleted', idsToDelete);
              }
              return of(null);
            })
          )
        );

      const failureObservables = this.smDataService.offlinePostCallList
        .filter(val => !val.success)
        .map(val =>
          this.smOfflineService.addorUpdateRecord<any>('SM_OfflineSyncFail', {
            url: val.url,
            payload: val.payload,
            insertDate: new Date(),
            result: val.result,
            deleteID: val.id,
          })
        );

      if (failureObservables.length) {
        this.smDataService.haveOfflinePostFail = true;
      }

      const allObservables = [...deleteObservables, ...workCompletedDeletionObservables, ...failureObservables];

      if (allObservables.length > 0) {
        this.subscriptions.push(
          forkJoin(allObservables).subscribe({
            next: () => {
              this.smDataService.offlinePostCallList = null;
              this.smDataService.haveOfflinePost = false;
              location.reload();
            },
            error: () => {
              this.smDataService.offlinePostCallList = null;
              this.smDataService.haveOfflinePost = false;
              location.reload();
            },
          })
        );
      } else {
        this.smDataService.offlinePostCallList = null;
        this.smDataService.haveOfflinePost = false;
        location.reload();
      }
      return false;
    }

    if (index < this.smDataService.offlinePostCallList.length) {
      this.smService
        .offlinePost(this.smDataService.offlinePostCallList[index].url, this.smDataService.offlinePostCallList[index].payload)
        .then((response: any) => {
          this.smDataService.offlinePostCallList[index].success = response.success;
          if (!response.success) {
            this.smDataService.offlinePostCallList[index].result = response;
          }
          index++;
          this.startOfflinePost(index);
        });
    }
  }

  public clearDB() {
    const modalRef = this.ngbModalService.open(ConfirmationModalComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.body = 'Are you sure you want to clear the local database?';
    modalRef.componentInstance.header = 'Clear Local Database';

    modalRef.result.then(response => {
      if (response != null) {
        this.eventService.broadcast('smClearDatabase');
        this.smOfflineService.clearDB().subscribe(() => {
          this.utilityService.closeModal();
        });
        this.smDataService.tripList.forEach(val => {
          val.ReadyOffline = false;
        });
      }
    });
  }

  private checkofflinePost() {
    if (!this.smDataService.haveOfflinePost) {
      this.smDataService.navbarHeight = 0;
    }
  }

  public saveURL() {
    this.utilityService.openModal();
    sessionStorage.setItem('previousSM', 'true');
    window.location.href = '/timecard/index';
    this.closeGlobalNav(null);
    //this.router.navigate(['/timecard/index'])
  }

  public routeToHome() {
    this.utilityService.openModal();
    this.smDataService.tripList = null;
    this.smDataService.tripListFiltered = null;
    this.smSharedService.removeSession();
    this.smSharedService.resetPage(false, false, false);
  }

  public turnoffOffline() {
    this.formData.enableOfflineAccess = false;
    this.userSettingUpdate(true);
  }

  public userSettingUpdate(reload) {
    setTimeout(() => {
      this.smService.updateSettings(this.formData.enableOfflineAccess).then((response: any) => {
        if (response.success) this.employeeInfo.EnableOfflineFS = this.formData.enableOfflineAccess;
        if (reload) {
          window.location.reload();
        }
      });
    });
  }

  public logout() {
    sessionStorage.clear();
    this.utilityService.isLoggedOut = true;
    window.location.href = '/account/logout?serviceWorker=true';
  }

  @HostListener('window:load', ['$event'])
  onLoad(e: KeyboardEvent) {
    this.smDataService.currentOnline = navigator.onLine;
  }

  @HostListener('window:offline', ['$event'])
  onOffline(e: KeyboardEvent) {
    this.smDataService.currentOnline = false;
  }

  @HostListener('window:online', ['$event'])
  onOnline(e: KeyboardEvent) {
    this.smDataService.currentOnline = true;
    setTimeout(() => {
      if (this.smDataService.enablePWA) {
        this.smDataService.currentOnline = true;

        this.smOfflineService.loadOfflinePostCalls().subscribe();
        this.smOfflineService.loadOfflineSyncFailures().subscribe();
      }
    });
  }

  openServiceHubLink(): void {
    try {
      const url = new URL(this.serviceHubLink);
      this.window.open(url, '_blank');
    } catch {
      /* empty */
    }
  }
}
